<template>
  <teleport to="body">
    <transition-group name="toast">
      <toast
        v-for="item in toasts"
        :key="item.id"
        :message="item.message"
        :type="item.type"
        :title="item.title"
        :action-text="item.actionText"
        :on-action="item.onAction"
        :style="{ bottom: `${16 + item.index * 80}px` }"
        @close="removeToast(item.id)"
      />
    </transition-group>
  </teleport>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { init } from './toast'
import type { ToastProps } from './toast'
import Toast from './Toast.vue'

type ToastItem = ToastProps & {
  id: number
  index: number
}

const toasts = ref<ToastItem[]>([])
let toastId = 0

function show(props: ToastProps) {
  const id = toastId++
  const index = toasts.value.length

  toasts.value.push({
    ...props,
    id,
    index
  })

  const duration = props.duration ?? 3000

  setTimeout(() => {
    removeToast(id)
  }, duration)
}

function removeToast(id: number) {
  const index = toasts.value.findIndex(t => t.id === id)
  if (index !== -1) {
    toasts.value.splice(index, 1)
    // Update indices for remaining toasts
    toasts.value.forEach((toast, i) => {
      toast.index = i
    })
  }
}

init(show)
</script>

<style scoped>
.toast-enter-active {
  animation: slide-up 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.toast-leave-active {
  animation: slide-down 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.toast-move {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes slide-up {
  from {
    transform: translate(-50%, calc(100% + 80px));
    opacity: 0;
  }
  to {
    transform: translate(-50%, 0);
    opacity: 1;
  }
}

@keyframes slide-down {
  from {
    transform: translate(-50%, 0);
    opacity: 1;
  }
  to {
    transform: translate(-50%, calc(100% + 80px));
    opacity: 0;
  }
}
</style>
